import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger } from "@fluentui/react-components";
import React, { useCallback } from "react";

import { LogCategory } from "Enumerations";
import { observer } from "mobx-react";
import { useLogging } from "Shared/Hooks";
import { useRootStore } from "Store/RootStore";
import { useStyles } from "./AppMenuSetting.styles";
import { useORPCQuery } from "Core/oRPC";
import { useMutation } from "@tanstack/react-query";

const ResetAllBase = () => {
    const styles = useStyles();
    const { coreApi } = useORPCQuery();
    const settingStorageKey = useRootStore("SettingStorageKey");
    const { trackEvent } = useLogging(LogCategory.Dashboard);
    const mutate = useMutation(
        coreApi.deleteGlobalSetting.mutationOptions({
            onSuccess: () => {
                location.reload();
            }
        })
    );

    const onClick = useCallback(() => {
        trackEvent("e78ec37a-581c-45a6-ac21-0ef1ad2c3d5b", "Reset_All_Configuration");
        localStorage.removeItem(settingStorageKey);
        mutate.mutate({ query: { settingName: settingStorageKey } });
    }, [mutate, settingStorageKey, trackEvent]);

    return (
        <Dialog>
            <DialogTrigger disableButtonEnhancement>
                <Button className={styles.resetButton}>Reset all settings</Button>
            </DialogTrigger>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>Warning</DialogTitle>
                    <DialogContent>
                        Clicking Reset button will delete all your settings including configuration settings and dashboard views, are you sure?
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary">Close</Button>
                        </DialogTrigger>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="primary" onClick={onClick}>
                                Reset
                            </Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export const ResetAll = observer(ResetAllBase);
